import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { ProductModel, WishListLineModel } from "@insite/client-framework/Types/ApiModels";

export function myListProductIsPurchasableOnWeb(product: ProductModel) {
    if (product.properties.nonPurchasableOnWeb === undefined) {
        return true;
    }
    return (
        product.properties.nonPurchasableOnWeb === undefined ||
        product.properties.nonPurchasableOnWeb.toLowerCase() === "false"
    );
}

export function getCanAddListToCartIfProductsArePurchesable(wishListLines: WishListLineModel[] | null | undefined) {
    let canAddListToCartIfProductsArePurchesable = true;

    if (wishListLines && wishListLines !== undefined && wishListLines !== null) {
        if (wishListLines.length > 0) {
            wishListLines.forEach(wishListLine => {
                if (
                    !(
                        wishListLine.properties.nonPurchasableOnWeb === undefined ||
                        wishListLine.properties.nonPurchasableOnWeb.toLowerCase() === "false"
                    )
                ) {
                    canAddListToCartIfProductsArePurchesable = false;
                }
            });
        }
    }
    return canAddListToCartIfProductsArePurchesable;
}

export function getCanAddSelectedToCartIfProductsArePurchesable(
    wishListLines: WishListLineModel[] | undefined,
    selectedIds: string[],
) {
    let canAddListToCartIfProductsArePurchesable = true;

    if (selectedIds.length > 0) {
        if (wishListLines !== undefined) {
            selectedIds.forEach(selectedId => {
                const wishListLine = wishListLines.find(p => p.id === selectedId);
                if (wishListLine !== undefined) {
                    if (
                        !(
                            wishListLine.properties.nonPurchasableOnWeb === undefined ||
                            wishListLine.properties.nonPurchasableOnWeb.toLowerCase() === "false"
                        )
                    ) {
                        canAddListToCartIfProductsArePurchesable = false;
                    }
                }
            });
        }
    }

    return canAddListToCartIfProductsArePurchesable;
}

export function myListProductIsDiscontinued(wishListLine: WishListLineModel, productInfo: ProductInfo) {
    if (wishListLine.properties.discontinuedStatus === undefined) {
        return false;
    }
    return (
        wishListLine.properties.discontinuedStatus.toLowerCase() === "discontinued"
    );
}

export function myListProductIsTempNotForSale(wishListLine: WishListLineModel) {
    if (wishListLine.properties.discontinuedStatus === undefined) {
        return false;
    }
    return wishListLine.properties.discontinuedStatus.toLowerCase() === "temp not for sale";
}

export function myListProductToBeDiscontinued(wishListLine: WishListLineModel) {
    if (wishListLine.properties.discontinuedStatus === undefined) {
        return false;
    }
    return wishListLine.properties.discontinuedStatus.toLowerCase() === "to be discontinued";
}

export function myListProductPartNumberChange(wishListLine: WishListLineModel) {
    if (wishListLine.properties.discontinuedStatus === undefined) {
        return false;
    }
    return wishListLine.properties.discontinuedStatus.toLowerCase() === "part number change";
}

export function getCanAddListToCartIfProductsAreNotDiscontinued(wishListLines: WishListLineModel[] | null | undefined) {
    let canAddListToCartIfProductsAreNotDiscontinued = true;

    if (wishListLines && wishListLines !== undefined && wishListLines !== null) {
        if (wishListLines.length > 0) {
            wishListLines.forEach(wishListLine => {
                if (
                    wishListLine.properties.discontinuedStatus !== undefined &&
                    wishListLine.properties.discontinuedStatus.toLowerCase() === "discontinued"
                ) {
                    canAddListToCartIfProductsAreNotDiscontinued = false;
                }
            });
        }
    }
    return canAddListToCartIfProductsAreNotDiscontinued;
}

export function getCanAddSelectedToCartIfProductsAreNotDiscontinued(
    wishListLines: WishListLineModel[] | undefined,
    selectedIds: string[],
) {
    let canAddListToCartIfProductsAreNotDiscontinued = true;

    if (selectedIds.length > 0) {
        if (wishListLines !== undefined) {
            selectedIds.forEach(selectedId => {
                const wishListLine = wishListLines.find(p => p.id === selectedId);
                if (wishListLine !== undefined) {
                    if (
                        wishListLine.properties.discontinuedStatus !== undefined &&
                        wishListLine.properties.discontinuedStatus.toLowerCase() === "discontinued"
                    ) {
                        canAddListToCartIfProductsAreNotDiscontinued = false;
                    }
                }
            });
        }
    }

    return canAddListToCartIfProductsAreNotDiscontinued;
}

export function getCanAddListToCartIfProductsAreNotTempNotForSale(wishListLines: WishListLineModel[] | null | undefined) {
    let canAddListToCartIfProductsAreNotTempNotForSale = true;

    if (wishListLines && wishListLines !== undefined && wishListLines !== null) {
        if (wishListLines.length > 0) {
            wishListLines.forEach(wishListLine => {
                if (
                    wishListLine.properties.discontinuedStatus !== undefined &&
                    wishListLine.properties.discontinuedStatus.toLowerCase() === "temp not for sale"
                ) {
                    canAddListToCartIfProductsAreNotTempNotForSale = false;
                }
            });
        }
    }
    return canAddListToCartIfProductsAreNotTempNotForSale;
}

export function getCanAddSelectedToCartIfProductsAreNotTempNotForSale(
    wishListLines: WishListLineModel[] | undefined,
    selectedIds: string[],
) {
    let canAddListToCartIfProductsAreNotTempNotForSale = true;

    if (selectedIds.length > 0) {
        if (wishListLines !== undefined) {
            selectedIds.forEach(selectedId => {
                const wishListLine = wishListLines.find(p => p.id === selectedId);
                if (wishListLine !== undefined) {
                    if (
                        wishListLine.properties.discontinuedStatus !== undefined &&
                        wishListLine.properties.discontinuedStatus.toLowerCase() === "temp not for sale"
                    ) {
                        canAddListToCartIfProductsAreNotTempNotForSale = false;
                    }
                }
            });
        }
    }

    return canAddListToCartIfProductsAreNotTempNotForSale;
}

export function wishListLineHasInventory(state: ApplicationState, productContext: ProductContextModel | undefined) {
    if (!productContext || !productContext.productInfo) {
        return null;
    }

    const {
        productInfo: { inventory, unitOfMeasure },
    } = productContext;

    const inventoryAvailability = inventory?.inventoryAvailabilityDtos?.find(o => o.unitOfMeasure === unitOfMeasure);

    return inventoryAvailability?.availability || null;
}

export function areAllToBeDiscontinuedItemsInStock(
    wishListLines: WishListLineModel[] | null | undefined,
    productInfosByWishListLineId: { [key: string]: ProductInfo | undefined }
) {
    if (!wishListLines) {
        return true;
    }

    for (const wishListLine of wishListLines) {
        const wishListLineId = wishListLine.id;
        const isToBeDiscontinued = wishListLine.properties.discontinuedStatus?.toLowerCase() === "to be discontinued";

        if (isToBeDiscontinued) {
            const inventoryAvailability = productInfosByWishListLineId[wishListLineId]?.inventory?.inventoryAvailabilityDtos?.find(
                o => o.unitOfMeasure === productInfosByWishListLineId[wishListLineId]?.unitOfMeasure
            );

            if (inventoryAvailability && inventoryAvailability.availability?.messageType === 2) {
                return false;
            }
        }
    }
    return true;
}

export function areAllSelectedToBeDiscontinuedItemsInStock(
    wishListLines: WishListLineModel[] | null | undefined,
    selectedIds: string[],
    productInfosByWishListLineId: { [key: string]: ProductInfo | undefined }
) {
    if (!wishListLines || selectedIds.length === 0) {
        return true;
    }

    for (const selectedId of selectedIds) {
        const wishListLine = wishListLines.find(line => line.id === selectedId);
        if (!wishListLine) { continue; }

        const isToBeDiscontinued = wishListLine.properties.discontinuedStatus?.toLowerCase() === "to be discontinued";

        if (isToBeDiscontinued) {
            const inventoryAvailability = productInfosByWishListLineId[wishListLine.id]?.inventory?.inventoryAvailabilityDtos?.find(
                o => o.unitOfMeasure === productInfosByWishListLineId[wishListLine.id]?.unitOfMeasure
            );

            if (inventoryAvailability && inventoryAvailability.availability?.messageType === 2) {
                return false;
            }
        }
    }
    return true;
}

export function areAllPartNumberChangeItemsInStock(
    wishListLines: WishListLineModel[] | null | undefined,
    productInfosByWishListLineId: { [key: string]: ProductInfo | undefined }
) {
    if (!wishListLines) {
        return true;
    }

    for (const wishListLine of wishListLines) {
        const wishListLineId = wishListLine.id;
        const isPartNumberChange = wishListLine.properties.discontinuedStatus?.toLowerCase() === "part number change";

        if (isPartNumberChange) {
            const inventoryAvailability = productInfosByWishListLineId[wishListLineId]?.inventory?.inventoryAvailabilityDtos?.find(
                o => o.unitOfMeasure === productInfosByWishListLineId[wishListLineId]?.unitOfMeasure
            );

            if (inventoryAvailability && inventoryAvailability.availability?.messageType === 2) {
                return false;
            }
        }
    }
    return true;
}

export function areAllSelectedPartNumberChangeItemsInStock(
    wishListLines: WishListLineModel[] | null | undefined,
    selectedIds: string[],
    productInfosByWishListLineId: { [key: string]: ProductInfo | undefined }
) {
    if (!wishListLines || selectedIds.length === 0) {
        return true;
    }

    for (const selectedId of selectedIds) {
        const wishListLine = wishListLines.find(line => line.id === selectedId);
        if (!wishListLine) { continue; }

        const isPartNumberChange = wishListLine.properties.discontinuedStatus?.toLowerCase() === "part number change";

        if (isPartNumberChange) {
            const inventoryAvailability = productInfosByWishListLineId[wishListLine.id]?.inventory?.inventoryAvailabilityDtos?.find(
                o => o.unitOfMeasure === productInfosByWishListLineId[wishListLine.id]?.unitOfMeasure
            );

            if (inventoryAvailability && inventoryAvailability.availability?.messageType === 2) {
                return false;
            }
        }
    }
    return true;
}